import React from 'react';
import { kpiIcons, iconSize, palette } from '../utils/designTokens';
import { Activity, Layers, Coins, Brain, Users, TrendingUp, ArrowLeftRight, DollarSign, GitBranch, Wrench } from 'lucide-react';

export default function KPIIcon({ type, status, size = 'default' }) {
  if (!type) throw new Error('KPIIcon requires type prop');
  if (!status) throw new Error('KPIIcon requires status prop');

  const colors = {
    good: palette.status.success,
    warning: palette.status.warning,
    danger: palette.status.danger,
    neutral: palette.text.neutral, // Warm neutral (Pastel Taupe) for better visibility
  };

  if (!colors[status]) throw new Error(`Invalid status: ${status}`);
  const color = colors[status];

  // Size mapping
  const sizeClass = size === 'large' ? iconSize.lg : iconSize.xs;

  // Map icon types to either kpiIcons tokens or Lucide icons
  const iconMap = {
    // KPI metrics from design tokens
    errorrate: kpiIcons.errorRate,
    p95: kpiIcons.latency,
    promptinjections: kpiIcons.security,
    dataexfiltrations: kpiIcons.dataExfiltration,

    // Overview KPI dimensions
    performance: kpiIcons.performance,
    quality: kpiIcons.quality,
    security: kpiIcons.security,
    reliability: kpiIcons.reliability,
    resiliency: kpiIcons.resiliency,
    optimization: kpiIcons.optimization,

    // Additional Lucide icons for other KPIs
    traces: Activity,
    spans: Layers,
    tokens: Coins,
    models: Brain,
    agents: Users,
    trendingup: TrendingUp,
    arrowrightleft: ArrowLeftRight,
    llmspend: DollarSign,
    handoffs: GitBranch,
    alerttriangle: kpiIcons.reliability,
    tools: Wrench,
  };

  const IconComponent = iconMap[type];
  if (!IconComponent) throw new Error(`Icon not found: ${type}`);

  return <IconComponent className={sizeClass} color={color} />;
}
